<div class="wrapper">
  <div class="block-center mt-4 wd-xl">
    <!-- START card-->
    <div class="card card-flat">
      <div class="card-header text-center bg-dark">
        <a href="#">
          <img class="block-center rounded" src="assets/img/logo.png" alt="Image" />
        </a>
      </div>
      <div class="card-body">
        <p class="text-center py-2">SIGNUP TO GET INSTANT ACCESS.</p>
        <form [formGroup]="valForm" class="form-validate mb-3" role="form" name="registerForm" novalidate="" (submit)="submitForm($event, valForm.value)">
          <div class="form-group">
            <label class="text-muted mb-1">Email address</label>
            <div class="input-group with-focus">
              <input class="form-control border-right-0" type="email" name="account_email" placeholder="Enter email" autocomplete="off" formControlName="email" required="" />
              <div class="input-group-append">
                <span class="input-group-text text-muted bg-transparent border-left-0">
                  <em class="fa fa-envelope"></em>
                </span>
              </div>
            </div>
            @if (valForm.controls['email'].hasError('required') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)) {
              <div class="text-danger">This field is required</div>
            }
            @if (valForm.controls['email'].hasError('email') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)) {
              <div class="text-danger">This field must be a valid email address</div>
            }
          </div>
          <div formGroupName="passwordGroup">
            <div class="form-group">
              <label class="text-muted mb-1">Password</label>
              <div class="input-group with-focus">
                <input class="form-control border-right-0" id="id-password" type="password" name="password" formControlName="password" [formControl]="valForm.get('passwordGroup.password')" />
                <div class="input-group-append">
                  <span class="input-group-text text-muted bg-transparent border-left-0">
                    <em class="fa fa-lock"></em>
                  </span>
                </div>
              </div>
              @if (valForm.get('passwordGroup.password').hasError('required') && (valForm.get('passwordGroup.password').dirty || valForm.get('passwordGroup.password').touched)) {
                <div class="text-danger">This field is required</div>
              }
              @if (valForm.get('passwordGroup.password').hasError('pattern') && (valForm.get('passwordGroup.password').dirty || valForm.get('passwordGroup.password').touched)) {
                <div class="text-danger">Input should match 'a-zA-Z0-9' and 6-10 length</div>
              }
            </div>
            <div class="form-group">
              <label class="text-muted mb-1">Retype Password</label>
              <div class="input-group with-focus">
                <input class="form-control border-right-0" type="password" name="confirmPassword" formControlName="confirmPassword" [formControl]="valForm.get('passwordGroup.confirmPassword')" />
                <div class="input-group-append">
                  <span class="input-group-text text-muted bg-transparent border-left-0">
                    <em class="fa fa-lock"></em>
                  </span>
                </div>
              </div>
              @if (valForm.get('passwordGroup.confirmPassword').hasError('required') && (valForm.get('passwordGroup.confirmPassword').dirty || valForm.get('passwordGroup.confirmPassword').touched)) {
                <div class="text-danger">This field is required</div>
              }
              @if (valForm.get('passwordGroup.confirmPassword').hasError('equalTo')) {
                <div class="text-danger">Password does Not match</div>
              }
            </div>
          </div>
          <div class="clearfix">
            <div class="checkbox c-checkbox float-left mt0">
              <label>
                <input type="checkbox" required="" name="account_agreed" formControlName="accountagreed" />
                <span class="fa fa-check"></span>I agree with the
                <a href="#">terms</a>
              </label>
            </div>
          </div>
          @if (valForm.controls['accountagreed'].hasError('required') && (valForm.controls['accountagreed'].dirty || valForm.controls['accountagreed'].touched)) {
            <span class="text-danger">You must agree the terms</span>
          }
          <button class="btn btn-block btn-primary mt-3" type="submit">Create account</button>
        </form>
        <!-- <div class="alert alert-danger text-center"></div> -->
        <p class="pt-3 text-center">Have an account?</p>
        <a class="btn btn-block btn-secondary" [routerLink]="'/login'">Signup</a>
      </div>
    </div>
    <!-- END card-->
    <div class="p-3 text-center">
      <span>&copy;</span>
      <span>{{ settings.getAppSetting('year') }}</span>
      <span class="mx-2">-</span>
      <span>{{ settings.getAppSetting('name') }}</span>
      <br/>
      <span>{{ settings.getAppSetting('description') }}</span>
    </div>
  </div>
</div>
